import { initialState } from '../constants';
import { createReducer } from '../helpers';
import { UpgradeRequestsReducerHandlers, GeneralReducerHandlers } from './handlers';
import { GeneralActionTypes } from '../actions/types';

const upgradeRequestsReducer = createReducer(
  initialState,
  {
    [GeneralActionTypes.resetStore]: GeneralReducerHandlers.resetStore(initialState),
    ...UpgradeRequestsReducerHandlers.getUpgradeRequests,
    ...UpgradeRequestsReducerHandlers.getUpgradeRequestsForExcel,
  },
);

export default upgradeRequestsReducer;
